import { Navigate, useLocation } from 'react-router'

import { isBusinessAccountsCatalogParam } from '@/lib/product-preselect'

export function RootAccountsRedirect() {
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const targetPath = isBusinessAccountsCatalogParam(searchParams) ? '/business/accounts' : '/accounts'

  return <Navigate to={`${targetPath}${location.search}`} replace />
}
